import { render } from "./MainParent.vue?vue&type=template&id=1625ee8c"
import script from "./MainParent.vue?vue&type=script&lang=js"
export * from "./MainParent.vue?vue&type=script&lang=js"

import "./MainParent.vue?vue&type=style&index=0&id=1625ee8c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__